import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import styles from './ProviderButton.module.scss';

const ProviderButton = ({ name, url, handleMVPDSelect }) => (
  <button className={styles.providerBtn} onClick={handleMVPDSelect}>
    <Link>
      <div className={styles.imageContainer}>
        <img className={styles.image} src={url} alt={name} />
      </div>
    </Link>
  </button>
);

export default ProviderButton;

ProviderButton.propTypes = {
  name: PropTypes.string,
  url: PropTypes.string,
  handleMVPDSelect: PropTypes.func,
};
